import React from 'react';

const formatCurrency = (amount: number) => {
  if (amount === undefined || amount === null) return 'SAR 0';
  return new Intl.NumberFormat('en-SA', {
    style: 'currency',
    currency: 'SAR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(amount);
};

const getProductCodeLabel = (code: string) => {
  const labels: Record<string, string> = {
    CRC: 'Credit Card',
    AQAR: 'Real Estate',
    MTG: 'Mortgage',
    MFL: 'Microfinance Loan',
    PL: 'Personal Loan',
    AL: 'Auto Loan'
  };
  return labels[code] || code;
};

const ConditionalApprovalSection: React.FC<{ stage: any }> = ({ stage }) => {
  const data = stage?.outputResult?.data?.data;
  if (!data) return null;

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 border-b pb-2">Conditional Approval</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <div>
          <div className="text-xs text-gray-500">Requested Finance Amount</div>
          <div className="font-semibold text-blue-700">{formatCurrency(stage?.outputResult?.data?.data?.requestedFinanceAmount)}</div>
        </div>
        <div>
          <div className="text-xs text-gray-500">Approved Finance Amount</div>
          <div className="font-semibold text-green-700">{formatCurrency(stage?.outputResult?.data?.data?.approvedFinanceAmount)}</div>
        </div>
      </div>
      <h4 className="text-md font-semibold text-gray-700 mb-2">Settable Liabilities</h4>
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs text-left bg-white rounded border">
          <thead className="bg-gray-100 text-gray-600 uppercase font-medium">
            <tr>
              <th className="p-2 border-b">Product</th>
              <th className="p-2 border-b">Outstanding</th>
              <th className="p-2 border-b">Limit</th>
              <th className="p-2 border-b">Finance Amount</th>
              <th className="p-2 border-b">New Obligations</th>
              <th className="p-2 border-b">Payment History</th>
              <th className="p-2 border-b">Active</th>
              <th className="p-2 border-b">Issue Date</th>
            </tr>
          </thead>
          <tbody>
            {data.settableLiabilities?.map((liab: any, idx: number) => (
              <tr key={idx} className="border-b">
                <td className="p-2 font-medium">{getProductCodeLabel(liab.creditInstrument.productCode)}</td>
                <td className="p-2">{formatCurrency(liab.creditInstrument.outstandingBalance)}</td>
                <td className="p-2">{formatCurrency(liab.creditInstrument.limit)}</td>
                <td className="p-2">{formatCurrency(liab.financeAmount)}</td>
                <td className="p-2">{formatCurrency(liab.newObligations)}</td>
                <td className="p-2 font-mono text-[10px]">{liab.creditInstrument.paymentHistoryCodes}</td>
                <td className="p-2">{liab.creditInstrument.isActive ? 'Yes' : 'No'}</td>
                <td className="p-2">{liab.creditInstrument.issueDate ? new Date(liab.creditInstrument.issueDate).toLocaleDateString() : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ConditionalApprovalSection;